import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

interface IManageCookieSettingsParams {
  showModal: boolean;
  cookieConsentGiven?: boolean;
}

export class ManageCookieSettingsAction extends BaseAction<void, IManageCookieSettingsParams> {
  override async run(): Promise<void> {
    try {
      const { showModal, cookieConsentGiven } = this.params!;

      if (showModal) {
        updateRecoilState('cookieConsentBannerVisibleAtom', false);
        updateRecoilState('cookieManagementModalVisibleAtom', true);
      } else {
        updateRecoilState('cookieManagementModalVisibleAtom', false);
        
        // If user hasn't given consent yet and closes modal, show banner again
        if (!cookieConsentGiven) {
          updateRecoilState('cookieConsentBannerVisibleAtom', true);
        }
      }
    } catch (error) {
      console.error("Error in ManageCookieSettingsAction:", error);
    }
  }
} 